import { useWallet, useWalletLedger } from '@/lib/walletHooks';
import { formatCurrencyEurRo, formatDateTimeRo } from '@/lib/format';
import { ledgerKindLabel, computeRunningBalances } from './format';

export function RegistruCredite() {
  const { data: w } = useWallet();
  const { data: page, isPending, isError } = useWalletLedger(50, 0);
  if (isPending) return <div className="h-40 animate-pulse rounded-2xl bg-wash" aria-hidden />;
  if (isError || !page) return <p className="text-[13.5px] text-bad">Nu s-a putut încărca registrul.</p>;
  if (page.items.length === 0) return <p className="text-[13.5px] text-ink-3">Nicio mișcare încă.</p>;
  // w may be undefined while the wallet query is pending/erroring — anchoring the
  // running balance to 0 in that case would fabricate wrong figures for a billing
  // registry, so „Sold curent" falls back to „—" instead (see `running` below).
  const running = w ? computeRunningBalances(page.items, w.balanceEur) : null;
  return (
    <div className="overflow-x-auto">
      <table className="w-full min-w-[520px] text-[13.5px]">
        <thead>
          <tr className="border-b border-rule text-left text-[11.5px] font-bold uppercase tracking-[0.05em] text-ink-3">
            <th className="px-5 py-2.5 font-bold sm:px-6">Dată</th>
            <th className="px-5 py-2.5 font-bold sm:px-6">Descriere</th>
            <th className="px-5 py-2.5 text-right font-bold sm:px-6">Sumă</th>
            <th className="px-5 py-2.5 text-right font-bold sm:px-6">Sold curent</th>
          </tr>
        </thead>
        <tbody>
          {page.items.map((it, i) => (
            <tr key={it.id} className="border-b border-rule-soft last:border-b-0 hover:bg-wash">
              <td className="px-5 py-2 tabular-nums text-ink-2 sm:px-6">{formatDateTimeRo(it.createdAt)}</td>
              {/* 2026-08-19 remediation Slice D, Task 3: `ledgerKindLabel` is a
                  DESCRIPTION of the movement (what kind of entry this is),
                  not a status — it no longer renders as a pill/chip. Plain
                  text also drops the previous `warn` tone on „Ajustare", a
                  refund, which read as a problem. */}
              <td className="px-5 py-2 text-ink-2 sm:px-6">{ledgerKindLabel(it.kind)}</td>
              <td className={`px-5 py-2 text-right tabular-nums sm:px-6 ${it.deltaEur < 0 ? 'text-mute' : 'text-ok'}`}>
                {it.deltaEur < 0 ? '−' : '+'}{formatCurrencyEurRo(Math.abs(it.deltaEur))}
              </td>
              <td className="px-5 py-2 text-right tabular-nums text-ink-2 sm:px-6">
                {running ? formatCurrencyEurRo(running[i]) : '—'}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
